<template>
    <div class="grid-view" v-if="view === 'grid'">
        <nuxt-link :to="{ path: 'estetiste/' + user.id + '-' + user.slug }" class="no-decoration">
            <div class="mb-3 text-center d-flex flex-column align-items-center">
                <user-image :user="user" size="100"></user-image>
                <div class="font-weight-bold mt-3">
                    {{ user.first_name }} {{ user.last_name }}
                    <profile-rank :user="user" position="center"></profile-rank>
                </div>
                <!--<span class="text-grey mt-1" v-if="user.specialisation1">{{ user.specialisation1.name }}</span>-->
                <review-rating class="mt-1" :rating="user.avg_rating" :size="14"></review-rating>
            </div>
        </nuxt-link>
    </div>
    <div class="list-view" v-else>
        <nuxt-link :to="{ path: '/estetiste/' + user.id + '-' + user.slug }" class="no-decoration">
            <div class="d-flex">
                <div class="d-flex">
                    <div class="image-container d-flex mr-2">
                        <user-image :user="user" size="60"></user-image>
                    </div>
                    <div class="ml-2">
                        <div class="font-weight-bold mr-3 font-size-lg">{{ user.first_name }} {{ user.last_name }}</div>
                        <profile-rank class="font-size-sm text-grey" :user="user" position="left"></profile-rank>
                        <div class="sign-up-date"></div>
                        <!--<div v-if="$auth.user && $auth.user.is_admin">-->
                            <!--<div class="user-info">-->
                                <!--<div class="user-icon">-->
                                    <!--<i class="cf-beautician"></i>-->
                                <!--</div>-->
                                <!--<div class="user-data">-->
                                    <!--<span class="mr-2">{{ $t('Specializzazione') }}</span>-->
                                    <!--<span class="text-black" v-if="user.specialisation1">{{ user.specialisation1.name }}</span>-->
                                    <!--<span v-else class="text-error">-->
                                        <!--{{ $t('Campo non compilato')}}-->
                                    <!--</span>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="user-info">-->
                                <!--<div class="user-icon">-->
                                    <!--<i class="cf-time"></i>-->
                                <!--</div>-->
                                <!--<div class="user-data">-->
                                    <!--<span class="mr-2">{{ $t('Esperienza') }}</span>-->
                                    <!--<span class="text-black" v-if="user.workExperiences">{{ user.workExperiences[0].name }}</span>-->
                                    <!--<span v-else class="text-error">-->
                                        <!--{{ $t('Campo non compilato')}}-->
                                    <!--</span>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="user-info">-->
                                <!--<div class="user-icon">-->
                                    <!--<i class="cf-pin"></i>-->
                                <!--</div>-->
                                <!--<div class="user-data">-->
                                    <!--<span class="mr-2">{{ $t('Indirizzo') }}</span>-->
                                    <!--<span class="text-black" v-if="user.address">{{ user.address }}</span>-->
                                    <!--<span v-else class="text-error">-->
                                        <!--{{ $t('Campo non compilato')}}-->
                                    <!--</span>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="user-info">-->
                                <!--<div class="user-icon">-->
                                    <!--<i class="cf-diploma"></i>-->
                                <!--</div>-->
                                <!--<div class="user-data">-->
                                    <!--<span class="mr-2">{{ $t('Formazione') }}</span>-->
                                    <!--<span class="text-black" v-if="user.certificates && user.certificates.length">{{ user.certificates[0].institute }}</span>-->
                                    <!--<span v-else class="text-error">-->
                                        <!--{{ $t('Campo non compilato')}}-->
                                    <!--</span>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="user-info">-->
                                <!--<div class="user-icon">-->
                                    <!--<i class="cf-diploma"></i>-->
                                <!--</div>-->
                                <!--<div class="user-data">-->
                                    <!--<span class="mr-2">{{ $t('Diploma') }}</span>-->
                                    <!--<nuxt-link :to="'/estetiste/' + user.id + '-' + user.slug + '?tab=certificates'" v-if="user.certificates && user.certificates.length">{{ $t('Verifica immagine') }}</nuxt-link>-->
                                    <!--<span v-else class="text-error">-->
                                        <!--{{ $t('Nessun diploma caricato') }}-->
                                    <!--</span>-->
                                <!--</div>-->
                            <!--</div>-->

                        <!--</div>-->
                        <div>
                            <div class="subtitle text-grey" v-if="user.specialisation1">
                                {{ user.specialisation1.name }}
                            </div>
                            <div class="subtitle text-grey" v-if="user.city">
                                {{ $t('Vive a')}} {{ user.city.name }}
                            </div>
                            <div class="d-flex align-items-center" v-if="user.avg_rating">
                                <span class="mr-2 vanitas text-brand review-score">{{ user.avg_rating ? user.avg_rating.toFixed(1) : '-' }}</span>
                                <review-rating :rating="user.avg_rating" :size="14"></review-rating>
                            </div>
                        </div>
                    </div>
                </div>
                <!--<div class="ml-auto mb-auto text-right" v-if="$auth.user && $auth.user.is_admin">-->
                    <!--<div class="mb-3">-->
                        <!--<slot name="dropdown-menu">-->
                            <!--<b-dropdown right no-caret variant="link">-->
                                <!--<template slot="button-content">-->
                                    <!--<i class="cf-more"></i>-->
                                <!--</template>-->
                                <!--<b-dropdown-item>{{ $t('Contatta in privato') }}</b-dropdown-item>-->
                                <!--<b-dropdown-item>{{ $t('Rifiuta richiesta') }}</b-dropdown-item>-->
                            <!--</b-dropdown>-->
                        <!--</slot>-->
                    <!--</div>-->
                <!--</div>-->
            </div>
        </nuxt-link>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    import UserImage from '~/components/UserImage'
    import ProfileRank from '~/components/ProfileRank'
    import ReviewRating from "../ReviewRating";

    export default {

        components: {
            ReviewRating,
            UserImage,
            ProfileRank
        },

        props: ['user', 'view'],

        mounted () {
        }
    }
</script>

<style lang="scss" scoped>

    .image-container {
        height: 75px;
        position: relative;

        .profile-rank {
            position:absolute;
            align-self: flex-end;
            justify-self: end;
            right: 0;
        }
    }

    .review-score {
        font-size: 18px;
    }

    .user-info {
        margin-bottom: 5px;
        display: flex;
        color: #8C8B8C;
        .user-icon {
            width: 20px;
            text-align: center;
            margin-right: 10px;
            color: #DBDBDB;
        }
        .value {
            color: #403D40;
        }
    }
</style>